<template>
    <div class="transac_tab_box">
        <div class="transac_wrap">
            <div v-if="type==0">
                <nav v-text="$t('m.component.top.nav[1]')"></nav>
                <ul @click=changeCur>
                    <li v-for="(v,k) of $t('m.order.nav')"
                        :key="k"
                        :data-index="k"
                        :class="{'cur':tabIndex==k}"
                        v-html="v"
                    >
                    </li>
                </ul>
            </div>
            <div v-if="type==1">
                <nav v-text="$t('m.component.top.nav[7]')"></nav>
                <ul @click=changeCur>
                    <li v-for="(v,k) of $t('m.component.top.invite')"
                        :key="k"
                        :data-index="k"
                        :class="{'cur':tabIndex==k}"
                        v-html="v"
                    >
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'entrTab',
        data() {
            return {
                tabList: [["/entrust/now", "/entrust/history", "/entrust/done"],
                    ["/invite/person", "/invite/reward", "/invite/code"]],

                tabIndex: 0,
                type: 0,
            }
        },

        created() {

        },
        mounted() {
            this.tabIndex = this.$route.query.tabIndex || 0;
            this.type = this.$route.query.type || 0;
        },
        methods: {
            changeCur: function (e) {
                if (e.target.nodeName.toLowerCase() === 'li') {
                    let index = parseInt(e.target.dataset.index);
                    this.tabIndex = index;
                    let url = this.tabList[this.type][index];
                    this.changeRoute(url, {tabIndex: this.tabIndex, type: this.type});
                }

            },
        }
    }
</script>
<style lang="scss">
    @import "../assets/css/minxin";

    .transac_tab_box {
        width: 100%;
        height: 82px;
        background-color: #1b2945;
    }

    .transac_tab_box .transac_wrap nav {
        float: left;
        font-size: 16px;
        color: #fff;
        line-height: 56px;
        padding-right: 80px;
    }

    .transac_tab_box .transac_wrap {
        width: 1200px;
        height: 100%;
        margin: auto;
        padding-top: 25px;
    }

    .transac_tab_box .transac_wrap ul {
        float: left;
    }

    .transac_tab_box .transac_wrap ul li {
        height: 56px;
        line-height: 56px;
        float: left;
        margin-right: 40px;
        cursor: pointer;
        display: inline-block;
        font-size: 14px;
        color: #87a2cd;
    }

    .transac_tab_box .transac_wrap ul li.cur {
        color: #fff;
        border-bottom: 3px solid $bottomColor;
    }

    .transac_tab_box .transac_wrap ul li:hover {
        color: #fff;
    }
</style>>
